/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface SnsAccountAlbaoneFeedError
 */
export interface SnsAccountAlbaoneFeedError {
    /**
     * 알바원 피드 에러 id
     * @type {number}
     * @memberof SnsAccountAlbaoneFeedError
     */
    'albaoneFeedErrorId': number;
    /**
     * 이름
     * @type {string}
     * @memberof SnsAccountAlbaoneFeedError
     */
    'name': SnsAccountAlbaoneFeedErrorNameEnum;
}

export const SnsAccountAlbaoneFeedErrorNameEnum = {
    UnavailableUsername: 'unavailable_username',
    TooManyRequest: 'too_many_request',
    OnlyOnFacebook: 'only_on_facebook',
    ContactRequired: 'contact_required',
    NotFound: 'not_found',
    FeedPostUploadError: 'feed_post_upload_error'
} as const;

export type SnsAccountAlbaoneFeedErrorNameEnum = typeof SnsAccountAlbaoneFeedErrorNameEnum[keyof typeof SnsAccountAlbaoneFeedErrorNameEnum];


